import React from 'react';
import Slider from 'react-slick';
import Service from '../service';
import balanceLogo from '../../images/balance_logo.svg';
import balanceLogoActive from '../../images/balance_logo_active.svg';
import barsLogo from '../../images/bars_logo.svg';
import barsLogoActive from '../../images/bars_logo_active.svg';
import handsLogo from '../../images/hands_logo.svg';
import handsLogoActive from '../../images/hands_logo_active.svg';
import filesLogo from '../../images/files_logo.svg';
import filesLogoActive from '../../images/files_logo_active.svg';
import puzzleLogo from '../../images/puzzle_logo.svg';
import puzzleLogoActive from '../../images/puzzle_logo_active.svg';

class Services extends React.Component {
  render() {
    const { taxAdvice, businessAdvice, servicesInCooperation, accounting, businessValuation } = this.props;
    const settings = {
      dots: true,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    return (
      <section className="services">
        <div className="container">
          <div className="services__teaser-text">
            <h3>Leistungen</h3>
          </div>
          <Slider {...settings}>
            { taxAdvice && (
              <Service
                icon={handsLogo}
                iconActive={handsLogoActive}
                link="/steuerberatung"
                title="Steuerberatung"
                text="Umfassende Beratung und Strukturierung in allen Ihren Steuerfragen"
              />)
            }
            { businessAdvice && (
              <Service
                icon={barsLogo}
                iconActive={barsLogoActive}
                link="/betriebswirtschaftliche-beratung"
                title="Betriebswirtschaftliche Beratung"
                text="Lösungsansätze für Ihre betriebswirtschaftlichen Fragestellungen"
              />)
            }
            {servicesInCooperation && (
              <Service
                icon={puzzleLogo}
                iconActive={puzzleLogoActive}
                link="/dienstleistungen-in-kooperation"
                title="Dienstleistungen in Kooperation"
                text="Interdisziplinäre Zusammenarbeit mit anderen um Ihnen weiterzuhelfen"
              />)
            }
            {accounting && (
              <Service
                icon={filesLogo}
                iconActive={filesLogoActive}
                link="/buchhaltung"
                title="Finanz-/ Lohnbuchhaltung"
                text="Wir entlasten Sie von den gesetzlich bestehenden Verpflichtungen"
              />)
            }
            {businessValuation && (
              <Service
                icon={balanceLogo}
                iconActive={balanceLogoActive}
                link="/unternehmensbewertung"
                title="Unternehmensbewertung"
                text='Die "Königsklasse" der Beratung bei Kauf/Verkauf/Übertragung'
              />)
            }
          </Slider>
        </div>
      </section>
    );
  }
}
export default Services;



// WEBPACK FOOTER //
// ./src/components/services/index.js